module.exports = __webpack_public_path__ + "static/media/Statua_046.05c093d8.jpg";